import React from "react";
import "./AirFreight.css";
import { FaPlane, FaClock, FaHandshake, FaMapMarkedAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

function AirFreight() {
  return (
    <div className="air-wrapper">

      {/* HERO SECTION */}
      <section className="air-hero">
        <div className="air-hero-container">

          <div className="air-hero-icon-title">
            <FaPlane size={48} className="air-icon-green" />
            <h1 className="air-hero-title">Accelerate Your Business with Fast & Reliable Air Freight</h1>
          </div>

          <p className="air-hero-subtext">
            Our air freight services ensure your cargo reaches destinations
            swiftly and securely — supported by real-time tracking and expert
            logistics planning.
          </p>

          <ul className="air-hero-points">
            <li><FaClock className="me-2" /> <strong>Speed:</strong> Fastest mode for urgent shipments.</li>
            <li><FaHandshake className="me-2" /> <strong>Reliability:</strong> Trusted airline partnerships.</li>
            <li><FaMapMarkedAlt className="me-2" /> <strong>Transparency:</strong> Real-time tracking & updates.</li>
          </ul>

          <Link to="/" className="air-back-btn">Back to Home</Link>
        </div>
      </section>

      {/* FEATURES GRID */}
      <section className="air-features-section">
        <div className="air-features-grid">

          <div className="air-feature-card">
            <h3>Fastest Global Deliveries</h3>
            <p>Move your cargo across the world in the shortest transit times.</p>
          </div>

          <div className="air-feature-card">
            <h3>Priority Handling</h3>
            <p>Sensitive shipments receive top-tier handling from start to finish.</p>
          </div>

          <div className="air-feature-card">
            <h3>Real-Time Tracking</h3>
            <p>Stay updated with live tracking for every movement.</p>
          </div>

          <div className="air-feature-card">
            <h3>Flexible Shipping Options</h3>
            <p>Choose express, economy, or consolidated air freight routes.</p>
          </div>

        </div>
      </section>

    </div>
  );
}

export default AirFreight;
